import {
    type FC
} from "react";
import {
    type NativeSyntheticEvent,
    type NativeScrollEvent,
    ScrollView,
    View
} from "react-native";
import type ISheetBodyProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSheetContext
} from "../../context";

const SheetBody: FC<ISheetBodyProps> = ({
    contentContainerStyle,
    children,
    onScroll,
    style,
    ...props
}) => {
    const sheet = useSheetContext({
        part: "Body"
    });

    const {
        spaces
    } = NCoreUIKitTheme.useContext(sheet?.customTheme);

    const {
        scrollContent: scrollContentDynamicStyle,
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    if(!sheet) {
        return null;
    }

    if(sheet.form === "bottom") {
        return <View
            style={[
                style,
                stylesheet.bottomContainer,
                containerDynamicStyle
            ]}
        >
            {children}
        </View>;
    }

    const onBodyScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
        sheet.setIsScrolled(event.nativeEvent.contentOffset.y > 0);

        if(onScroll) onScroll(event);
    };

    return <ScrollView
        keyboardShouldPersistTaps="handled"
        alwaysBounceVertical={false}
        scrollEventThrottle={1}
        {...props}
        contentContainerStyle={[
            contentContainerStyle,
            stylesheet.scrollContent,
            scrollContentDynamicStyle
        ]}
        onScroll={onBodyScroll}
        style={[
            style,
            stylesheet.scroll
        ]}
    >
        {children}
    </ScrollView>;
};
export default SheetBody;
